/**
 * Mobile step menu for Bootstrap
 */
class MobileStepMenu {
	constructor() {
		this.init();
	}

	init() {
		$ = jQuery;
		const self = this;

		// Bind handlers directly to elements (not using delegation)
		// This ensures our handler runs with higher priority
		$(".dropdown-toggle").each(function() {
			// Remove any existing data-toggle attribute on mobile when menu opens
			// We'll handle it manually
		});

		// Switch to keyboard-nav mode on Tab.
		// Hide hover-opened dropdowns but NOT the one the user is currently inside.
		// On mouse click (pointerdown): clear inline styles and return to CSS/hover control.
		$(document).on("keydown.keyboardMode", function(e) {
			if (e.key !== "Tab") return;
			if ($("body").hasClass("mobile-open")) return; // mobile step-nav owns this
			$("body").addClass("keyboard-nav");
			var $active = $(document.activeElement);
			// The open dropdown that belongs to the active element's parent (if any)
			var $activeKO = $active.closest(".keyboard-open");
			var activeKOMenu = $activeKO.length ? $activeKO.find("> .dropdown-menu")[0] : null;
			$("#site-navbar .dropdown-menu").each(function() {
				// Keep if: (a) it contains current focus, or (b) it's the currently open dropdown
				if (!$.contains(this, $active[0]) && this !== activeKOMenu) {
					$(this).css("display", "none");
				}
			});
		});
		$(document).on("pointerdown.keyboardMode", function(e) {
			if (e.originalEvent.pointerType === "touch") return;
			$("body").removeClass("keyboard-nav");
			// Clear inline display styles — CSS hover takes over again
			$(".keyboard-open").removeClass("keyboard-open")
				.find("> .dropdown-toggle").attr("aria-expanded", "false");
			$("#site-navbar .dropdown-menu").css("display", "");
		});

		// Remove data-toggle from all nav dropdowns so Bootstrap doesn't intercept keypresses.
		$("#site-navbar .dropdown-toggle").each(function() {
			var $this = $(this);
			$this.data("original-toggle", $this.attr("data-toggle") || "dropdown");
			$this.removeAttr("data-toggle");
		});

		// Give tabindex="0" to top-level toggles without href so they're reachable by Tab.
		// Nested items are inside display:none dropdowns when closed, so they're naturally
		// excluded from the tab order — no need to set tabindex="-1".
		$("#site-navbar .navbar-nav > .menu-item > .dropdown-toggle").each(function() {
			if (!$(this).attr("href") && !$(this).attr("tabindex")) {
				$(this).attr("tabindex", "0");
			}
		});

		// When mobile menu opens, disable data-toggle AND href
		$(".toggle-mainmenu").off("click");
		$(".toggle-mainmenu").on("click", function(e) {
			e.preventDefault();
			var $toggle = $(this);
			$("body").toggleClass("mobile-open");

			var isOpen = $("body").hasClass("mobile-open");
			$toggle.attr("aria-expanded", isOpen ? "true" : "false");
			$toggle.attr("aria-label", isOpen ? "Stäng meny" : "Öppna meny");

			// Remove data-toggle and store href when mobile menu opens
			if (isOpen) {
				$(".dropdown-toggle").each(function() {
					var $this = $(this);
					var currentHref = $this.attr("href");
					// Only store and manipulate href if it exists and is not empty or "#"
					if (currentHref && currentHref !== "" && currentHref !== "#") {
						// Store original href if not already stored
						if (!$this.data("original-href")) {
							$this.data("original-href", currentHref);
						}
						// Remove href to prevent navigation on mobile
						$this.removeAttr("href");
					}
					// Remove data-toggle
					$this.removeAttr("data-toggle");
				});
			} else {
				// Restore href and data-toggle when mobile menu closes
				$(".dropdown-toggle").each(function() {
					var $this = $(this);
					var originalHref = $this.data("original-href");
					var originalToggle = $this.data("original-toggle");
					// Only restore href if it was actually stored (not undefined or "#")
					if (originalHref && originalHref !== "" && originalHref !== "#") {
						$this.attr("href", originalHref);
					}
					if (originalToggle) {
						$this.attr("data-toggle", originalToggle);
					}
				});
				// Reset the step-nav slide transform so the nav is back at its desktop position
				$("#site-navbar > ul.navbar-nav").css("transform", "");
				// Remove step-back items injected by mobile navigation
				$("#site-navbar .step-back").remove();
				// Clear inline display styles from mobile step-nav so desktop CSS works again
				$("#site-navbar .dropdown-menu").css("display", "");
				$(".dropdown.keyboard-open").removeClass("keyboard-open")
					.find(".dropdown-toggle").attr("aria-expanded", "false");
				// Return focus to toggle button when menu closes
				$toggle.focus();
			}
		});

		// Unbind existing handlers to prevent duplicates
		// But preserve mega-menu handlers that were set up by mega-menu-images.js
		$(document).off("click", ".dropdown-toggle");
		$(".dropdown-toggle").not('.mega-menu.thumbnails a').off("click");

		// Bind click handler DIRECTLY to non-mega-menu dropdown toggles
		$(".dropdown-toggle").not('.mega-menu.thumbnails a').each(function() {
			$(this).on("click", function(e) {
				var is_mobile = $("body").hasClass("mobile-open");
				var $this = $(this);
				// On mobile, href is stored in data attribute
				var href = is_mobile ? $this.data("original-href") : $this.attr("href");

				// On mobile, check if click is in chevron area
				if (is_mobile && $this.parent().hasClass("menu-item-has-children")) {
					// ALWAYS prevent default on mobile for menu items with children
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();

					// If no href or href is "#", always open submenu regardless of click position
					if (!href || href === "#" || href === "") {
						var $parent = $this.parent();
						if ($parent.hasClass("dropdown")) {
							$parent.trigger("show.bs.dropdown");
						}
						return false;
					}

					// Has a valid href - check click position
					// Calculate click position
					var elementWidth = $this.outerWidth();
					var clickX = e.pageX - $this.offset().left;

					// Check if click is in the chevron area (right 47px based on CSS padding)
					var chevronZoneStart = elementWidth - 47;

					if (clickX >= chevronZoneStart) {
						// Clicked on chevron - open submenu
						// Trigger Bootstrap dropdown event manually
						var $parent = $this.parent();
						if ($parent.hasClass("dropdown")) {
							$parent.trigger("show.bs.dropdown");
						}
					} else {
						// Clicked on text - follow link
						window.location.href = href;
					}

					return false;
				}

				if (!is_mobile && href && href !== "#" && href !== "") {
					setTimeout(() => {
						window.location.href = href;
					}, 100);
				}
			});
		});

		// Handle mega-menu items on mobile - trigger Bootstrap dropdown for step-back navigation
		$('.mega-menu.thumbnails a.dropdown-toggle').each(function() {
			$(this).on("click", function(e) {
				var is_mobile = $("body").hasClass("mobile-open");

				// On mobile, trigger Bootstrap dropdown event for step navigation
				if (is_mobile) {
					e.preventDefault();
					e.stopPropagation();
					var $parent = $(this).parent();
					if ($parent.hasClass("dropdown")) {
						$parent.trigger("show.bs.dropdown");
					}
					return false;
				}
				// On desktop, let mega-menu-images.js handle it (do nothing here)
			});
		});

		// Desktop keyboard navigation — simple spec:
		// Enter: navigate if item has a URL, open submenu if not
		// Space or ArrowRight: always open submenu (if one exists)
		// Escape: close current submenu, return focus to toggle
		$(document).off("keydown.dropdownNav").on("keydown.dropdownNav", ".dropdown-toggle", function(e) {
			var is_mobile = $("body").hasClass("mobile-open");
			if (is_mobile) return;

			var $toggle = $(this);
			var $parent = $toggle.closest(".dropdown");
			var hasHref = !!$toggle.attr("href") && $toggle.attr("href") !== "#" && $toggle.attr("href") !== "";
			var hasSubmenu = $parent.find("> .dropdown-menu").length > 0;

			var closeSubmenu = function($item) {
				$item.removeClass("keyboard-open")
					.find("> .dropdown-menu").css("display", "none")
					.end()
					.find("> .dropdown-toggle").attr("aria-expanded", "false");
			};

			var openSubmenu = function() {
				if (!hasSubmenu) return;
				// Close siblings at the same level
				$parent.siblings(".keyboard-open").each(function() {
					closeSubmenu($(this));
				});
				$parent.addClass("keyboard-open");
				$toggle.attr("aria-expanded", "true");
				// Remove the inline display:none set by the Tab handler so the CSS
				// keyboard-open rule (display:flex) takes over naturally
				$parent.find("> .dropdown-menu").css("display", "");
			};

			if (e.key === "Enter") {
				if (hasHref) return; // let browser navigate to the URL
				e.preventDefault();
				openSubmenu();
			}

			if (e.key === " " || e.key === "ArrowRight") {
				e.preventDefault();
				openSubmenu();
			}

			if (e.key === "Escape" || e.key === "ArrowLeft") {
				e.preventDefault();
				closeSubmenu($parent);
				$toggle.focus();
			}
		});

		// Escape/ArrowLeft inside a dropdown: close it and return focus to toggle
		$(document).off("keydown.dropdownEsc").on("keydown.dropdownEsc", ".dropdown-menu a", function(e) {
			if (e.key === "Escape" || e.key === "ArrowLeft") {
				e.preventDefault();
				var $openParent = $(this).closest(".keyboard-open");
				if ($openParent.length) {
					$openParent.find("> .dropdown-menu").css("display", "none");
					$openParent.removeClass("keyboard-open")
						.find("> .dropdown-toggle").attr("aria-expanded", "false").focus();
				}
			}
		});

		// Close when focus leaves the open dropdown entirely
		$(document).off("focusout.dropdownNav").on("focusout.dropdownNav", ".keyboard-open", function() {
			var $d = $(this);
			setTimeout(function() {
				if (!$.contains($d[0], document.activeElement)) {
					$d.find("> .dropdown-menu").css("display", "none");
					$d.removeClass("keyboard-open")
						.find("> .dropdown-toggle").attr("aria-expanded", "false");
				}
			}, 100);
		});

		$(window).off("resize.mobileStepMenu");
		$(window).on("resize.mobileStepMenu", function() {
			if ($(window).width() >= 600) {
				$("body").removeClass("mobile-open");
				// $('.mega-menu ul').css('display', 'block');
				// $('.mega-menu > ul').css('display', 'none');
				$(".navbar .navbar-nav").removeAttr("style");
			}
		});

		// Safari fix - unbind first to prevent duplicates
		$("#site-navbar").off("click", "ul.navbar-nav .dropdown-menu");
		$("#site-navbar").on("click", "ul.navbar-nav .dropdown-menu", function(
			e
		) {
			var is_mobile = $("body").hasClass("mobile-open");
			var $list_item = $(e.target);

			// On desktop, don't interfere with mega-menu clicks - let mega-menu-images.js handle them
			if (!is_mobile && $(e.target).closest('.mega-menu.thumbnails').length > 0) {
				return;
			}

			if (!is_mobile && e.target.tagName == "A") {
				location.href = $list_item.attr("href");
				return;
			}

			if (!is_mobile) {
				return false;
			}

			if ($list_item.parent().hasClass("step-back")) {
				var depth = self.getNavigationDepth($list_item, "#site-navbar");
				var previousTitle = $list_item.text();
				var $subMenu = $list_item.parent().find("> .dropdown-menu");

				depth -= 2;

				previousTitle = $list_item
					.parents("li.menu-item-has-children")
					.eq(1)
					.find(" > a")
					.text();
				$subMenu = $list_item
					.parents("li.menu-item-has-children")
					.eq(1)
					.find("> .dropdown-menu");

				e.preventDefault();

				// Transform
				$("#site-navbar > ul.navbar-nav").css(
					"transform",
					"translateX(-" + depth * 100 + "%)"
				);

				// Hide previous sub menus
				$("#site-navbar > ul.navbar-nav .dropdown-menu").hide();

				// Get top most element and display all dropdowns
				$list_item
					.parents("li.menu-item-has-children")
					.each(function() {
						if (
							$(this)
								.parent()
								.hasClass("navbar-nav")
						) {
							$(this)
								.find(".dropdown-menu:not(.sub-menu)")
								.show();
						}
					});
			}
		});

		// Unbind existing Bootstrap dropdown handlers
		$("#site-navbar ul.navbar-nav > li.dropdown").off("show.bs.dropdown");

		$("#site-navbar ul.navbar-nav > li.dropdown").on(
			"show.bs.dropdown",
			function(e) {
				var is_mobile = $("body").hasClass("mobile-open");
				var $list_item = $(this).find("> a");
				var $target = $(e.target);

				// Allow normal Bootstrap dropdown behavior on desktop
				if (!is_mobile) {
					return true;
				}

				var depth = self.getNavigationDepth($list_item, "#site-navbar");
				var previousTitle = $list_item.text();
				var $subMenu = $list_item.parent().find("> .dropdown-menu");

				if ($list_item.hasClass("dropdown-toggle")) {
					// Sub-menu ?
					if (!$list_item.parent().hasClass("dropdown-submenu")) {
						// Create a skeleton menu link?
						if (depth >= 0) {
							$(
								"#site-navbar > ul.navbar-nav .step-back"
							).remove();
							$subMenu.prepend(
								'<li class="menu-item step-back d-flex d-md-none"><a href="#">' +
									previousTitle +
									"</a></li>"
							);
						}
					}
				} else if ($list_item.parent().hasClass("step-back")) {
					depth -= 2;

					previousTitle = $list_item
						.parents("li.menu-item-has-children")
						.eq(1)
						.find(" > a")
						.text();
					$subMenu = $list_item
						.parents("li.menu-item-has-children")
						.eq(1)
						.find("> .dropdown-menu");
				} else {
					return true;
				}

				// Check for sub-menu
				if ($target.hasClass("dropdown-submenu")) {
					let $a = $target.find("> a");
					$a.toggleClass("open");
				}

				e.preventDefault();

				// Transform
				$("#site-navbar > ul.navbar-nav").css(
					"transform",
					"translateX(-" + depth * 100 + "%)"
				);

				// Hide previous sub menus
				$("#site-navbar > ul.navbar-nav .dropdown-menu").hide();

				// Get top most element and display all dropdowns
				$list_item
					.parents("li.menu-item-has-children")
					.each(function() {
						if (
							$(this)
								.parent()
								.hasClass("navbar-nav")
						) {
							$(this)
								.find(".dropdown-menu:not(.sub-menu)")
								.show();
						}
					});
			}
		);
	}

	getNavigationDepth(elem, stop) {
		$ = jQuery;

		var $elem = $(elem).parentsUntil(stop);
		var depth = 1;

		$elem.each(function(e) {
			if ($(this).is("ul") && $(this).hasClass("dropdown-menu")) {
				depth++;
			}
		});

		return depth;
	}
}

export default MobileStepMenu;
